var generic = generic || {};

(function ($) {
  $(document).on('perlgem.user.fetch', function (e, deferred) {
    generic.jsonrpc.fetch({
      method: 'user.json',
      params: [],
      onSuccess: function (jsonRpcResponse) {
        const response = jsonRpcResponse.getValue();
        deferred.resolve({
          user_id: response.user_id,
          signed_in: response.signed_in,
          session_id: response.session_id
        });
      },
      onFailure: function (jsonRpcResponse) {
        deferred.reject(jsonRpcResponse.getError());
      }
    });
  });
})(jQuery);
